import { useContext } from 'react';
import ContextStates from '../context/ContextStates';
import Layout from '../components/Layout';
import ListMisPedidos from '../components/listMisPedidos';


const MisPedidos = () => {

	return (
		<Layout
			pagina={"Pedidos actuales"}
		>
			<div className='w-full pt-20 pb-20'>
                <ListMisPedidos />
			</div>
		</Layout>
	)
}

export default MisPedidos